var _path, _path2, _path3, _polygon, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMailbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M43,36H13V11h22c4.418,0,8,3.582,8,8V36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7debf5",
    d: "M21,36H5V19c0-4.418,3.582-8,8-8l0,0c4.418,0,8,3.582,8,8V36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M21,36h5v8h-5V36z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eb0000",
    points: "27,16 27,20 35,20 35,24 39,24 39,16"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 3,
    x: 9,
    y: 20,
    fill: "#3dd9eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailbox);
export default __webpack_public_path__ + "static/media/icon-mailbox.211bd2fed19329d8cdbc308bc9c6ae2e.svg";
export { ForwardRef as ReactComponent };